/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

const listingHoldingDetails = async (
  type: APIType,
  data: any = undefined,
  id: string = '',
  section: 'valueChain' | 'dataCollection' = 'valueChain'
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const res = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${
        section === 'valueChain'
          ? API_ENDPOINT_JSON.holding_valueChain
          : API_ENDPOINT_JSON.holding_dataCollection
      }/${getRouteIP(type, id)}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      useCompanyStore.setState({
        holding: res.data.data.map((item: any, i: number) => {
          return {...item, key: i};
        })
      });

      return res.data.data;
    } else {
      return res.data;
    }
  } catch (err: any) {
    const data = err?.response?.data;
    const message = data?.message || 'Something went wrong';
    const reloadSubscription = data?.reloadSubscription === true;

    return {status: 'error', message, reloadSubscription};
  }
};

export default listingHoldingDetails;
